import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

export const fetchCompanyChildAction = async () => {
  try {
    const response = await apiClient.get(ATP_API_URL.COMPANY_CHILD_DATA);
    // console.log("[CompanyChild] API response:", response?.data);

    if (response?.status === 200 && response.data) {
      const data = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      return { success: true, data };
    }

    return { success: false, data: [], error: "Failed to fetch company data" };
  } catch (error) {
    console.error("[CompanyChild] Error:", error.message);
    return { success: false, data: [], error: error.message };
  }
};
